export enum CloudNotificationStyle {
  success,
  danger,
  warning,
  info
}
